/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryviewsourcestitle3Inputs */

const en_summaryviewsourcestitle3 = /** @type {(inputs: Summaryviewsourcestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the views came from`)
};

const de_summaryviewsourcestitle3 = /** @type {(inputs: Summaryviewsourcestitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher die Aufrufe kamen`)
};

/**
* | output |
* | --- |
* | "Where the views came from" |
*
* @param {Summaryviewsourcestitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryviewsourcestitle3 = /** @type {((inputs?: Summaryviewsourcestitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryviewsourcestitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryviewsourcestitle3(inputs)
	return de_summaryviewsourcestitle3(inputs)
});
export { summaryviewsourcestitle3 as "summaryViewSourcesTitle" }